export default __webpack_public_path__ + "static/media/glasses7.4e6d083b.jpeg";